<!-- http://www.w3schools.com/bootstrap/bootstrap_forms_inputs.asp  
  -- provides information about many of the forms included here such as
  -- select, checkbox, and radio buttons
  --
  -- see https://www.npmjs.com/package/ng2-draggable  performed: npm install ng2-draggable
  -- see http://leafletjs.com/examples/choropleth.html for potential enhancement
  -->
<h4 class='legendTitle'>Map Legend</h4>
<!--
<svg width="15" height="15">
<circle cx="7" cy="7" r="4" stroke="green" stroke-width="4" fill="green" />
</svg>  Flow
<input type="button" class="btn btn-info" value="Refresh">
-->
<!-- In order to get the exact class for each icon, I copied the icon being
	used in the map, and called 'createIcon()' to see the html that would
	produce the same icon.  See map.component.ts.  Such as:

	var greenMarker = L.ExtraMarkers.icon({
			icon: 'fa-number',
			markerColor: 'green',
			shape: 'circle',
			prefix: 'fa',
			number: "99" 
		}).createIcon();
		 console.log(greenMarker);

-->
<div>  <!-- this wrapper class is so that nth-child in the .css works -->
<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-black extra-marker iconSymbol' style="position:relative" >
	<i number='NR' style='color: #fff' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-black.png"> 
</div>
<div class='iconDescription'>No report</div>
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-blue-dark extra-marker iconSymbol' style="position:relative" >
	<i number='OOS' style='color: #fff' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-blue-dark.png"> 
</div>
<div class='iconDescription'>Out of service</div>
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-green extra-marker iconSymbol' style="position:relative" >
	<i number='99' style='color: #fff' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-green.png"> 
</div>
<div class='iconDescription'>{{novaScoreDescription[1]}}<br>{{fitNovaScoreDescription[1]}}</div> <!-- novascore 1 -->
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-yellow extra-marker iconSymbol' style="position:relative" >
	<i number='99' style='color: #000' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-yellow.png"> 
</div>
<div class='iconDescription'>{{novaScoreDescription[2]}}<br>{{fitNovaScoreDescription[2]}}</div>
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-orange extra-marker iconSymbol' style="position:relative" >
	<i number='99' style='color: #000' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-orange.png"> 
</div>
<div class='iconDescription'>{{novaScoreDescription[3]}}<br>{{fitNovaScoreDescription[3]}}</div>
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-pink extra-marker iconSymbol' style="position:relative" >
	<i number='99' style='color: #000' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-pink.png"> 
</div>
<div class='iconDescription'>{{novaScoreDescription[4]}}<br>{{fitNovaScoreDescription[4]}}</div>
</div>

<div class="legendGroup">
	<!--
<div class='leaflet-market-icon extra-marker-square-red extra-marker iconSymbol' style="position:relative" >
	<i number='99' style='color: #fff' class='fa fa-number'></i>
</div>
	-->
<div class='iconSymbol' style="position:relative" >
	<img src="assets/images/ExtraMarkers/extra-marker-red.png"> 
</div>
<div class='iconDescription'>{{novaScoreDescription[5]}}<br>{{fitNovaScoreDescription[5]}}</div>
</div>

</div>
  